export const CATALOG_SORT_FIELDS = ['rate', 'created_at', 'title'];
// Kept for shared legacy links even when the current filter drawer hides them.
export const LEGACY_CATALOG_FACETS = ['color', 'environment', 'ripening_time', 'growth_type', 'blooming_time', 'fruiting_time'];
export const isCatalogTrackingParameter = name => /^utm_/i.test(name) || /^(?:gclid|yclid|fbclid|dclid|msclkid|ysclid|yrclid|_ga|uo_audit)$/i.test(name);

function invalid(code) {
    const error = new Error(code);
    error.code = code;
    throw error;
}
function values(value) {
    return (Array.isArray(value) ? value : [value]).filter(v => v !== undefined && v !== null && v !== '').map(v => {
        if (!['string', 'number'].includes(typeof v)) invalid('invalid_filter');
        return String(v);
    });
}
function single(value, fallback, code) {
    const list = values(value);
    if (list.length > 1) invalid(code);
    return list[0] ?? fallback;
}
export function catalogQueryControls(query = {}) {
    const rawPage = single(query.page, '1', 'invalid_page');
    const page = Number(rawPage);
    if (!/^\d+$/.test(rawPage) || !Number.isSafeInteger(page) || page < 1 || page > 1000000) invalid('invalid_page');
    const sort = single(query.sort, 'rate', 'invalid_sort');
    if (!CATALOG_SORT_FIELDS.includes(sort)) invalid('invalid_sort');
    const search = single(query.search, '', 'invalid_search').trim();
    if (search.length > 100 || /[\u0000-\u001f\u007f]/.test(search)) invalid('invalid_search');
    return {page, sort, search};
}
export function normalizeCatalogQuery(query = {}, allowedNames = []) {
    const controls = catalogQueryControls(query);
    const allowed = new Set([...LEGACY_CATALOG_FACETS, ...allowedNames, 'brands', 'rate']);
    const filters = {}, where = {}, normalizedQuery = {};
    let totalValues = 0;
    for (const [name, raw] of Object.entries(query)) {
        if (['page', 'sort', 'search'].includes(name) || isCatalogTrackingParameter(name)) continue;
        const list = [...new Set(values(raw))].sort();
        if (!list.length) continue;
        if (!allowed.has(name) || !/^[a-z][a-z0-9_]{0,60}$/.test(name)) invalid('invalid_filter');
        if (list.length > 50 || list.some(v => v.length > 100 || /[\u0000-\u001f\u007f]/.test(v))) invalid('invalid_filter');
        totalValues += list.length;
        if (totalValues > 200 || Object.keys(filters).length >= 40) invalid('invalid_filter');
        if (name === 'brands' && list.some(v => !/^[1-9]\d{0,9}$/.test(v) || Number(v) > 2147483647)) invalid('invalid_filter');
        if (name === 'rate' && list.some(v => !/^[1-5]$/.test(v))) invalid('invalid_filter');
        filters[name] = list;
        normalizedQuery[name] = list;
        if (name === 'brands') where.brands = {brand_id: {_in: list}};
        else if (name === 'rate') where.rate = {_in: list};
        else (where._and ||= []).push({params: {name: {_eq: name}, values: {_has_keys_any: list}}});
    }
    if (controls.page > 1) normalizedQuery.page = String(controls.page);
    if (values(query.sort).length) normalizedQuery.sort = controls.sort;
    if (controls.search) normalizedQuery.search = controls.search;
    return {...controls, filters, where, normalizedQuery};
}
export function catalogPageExists(page, total, limit = 48) {
    return Number.isSafeInteger(page) && page >= 1 && Number.isFinite(total) && total >= 0 && page <= Math.max(1, Math.ceil(total / limit));
}
